import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {
  Collapse,
  List,
  ListItem,
  Stack,
  Typography,
  Box,
} from "@mui/material";

import { useState } from "react";
import { useTranslation } from "react-i18next";

type AddActivitiesIntroProps = {
  hideForFM?: boolean;
};

export default function AddActivitiesIntro({
  hideForFM,
}: AddActivitiesIntroProps) {
  const [open, setOpen] = useState<boolean>(false);
  const { t } = useTranslation();
  const handleOpen = () => {
    setOpen(!open);
  };

  return (
    <>
      {!hideForFM && (
        <Box>
          <Typography variant="h5">
            {t("introductions.addActivities.header")}
          </Typography>
        </Box>
      )}
      <Box mt={2}>
        <Typography>{t("introductions.addActivities.text1")}</Typography>
      </Box>
      <Box mt={2}>
        <Typography>
          <strong>{t("labels.what")} </strong>
          {t("introductions.addActivities.whatText")}
        </Typography>
      </Box>
      <Box mt={2}>
        <Typography>
          <strong>{t("labels.why")} </strong>
          {t("introductions.addActivities.whyText")}
        </Typography>
      </Box>
      <Box mt={2}>
        <Typography>{t("introductions.addActivities.text2")}</Typography>
      </Box>
      <Box mt={2}>
        <Typography>{t("introductions.addActivities.text3")}</Typography>
      </Box>

      <Stack mt={1} direction={"row"} onClick={handleOpen}>
        <Typography color={"primary"}>
          {t("introductions.addActivities.activityExamples")}
        </Typography>
        {open ? (
          <ExpandLess color={"primary"} />
        ) : (
          <ExpandMore color={"primary"} />
        )}
      </Stack>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List>
          <ListItem>
            <Typography>
              - {t("introductions.addActivities.example1")}
            </Typography>
          </ListItem>
          <ListItem>
            <Typography>
              - {t("introductions.addActivities.example2")}
            </Typography>
          </ListItem>
          <ListItem>
            <Typography>
              - {t("introductions.addActivities.example3")}
            </Typography>
          </ListItem>
          <ListItem>
            <Typography>
              - {t("introductions.addActivities.example4")}
            </Typography>
          </ListItem>
          <ListItem>
            <Typography>
              - {t("introductions.addActivities.example5")}
            </Typography>
          </ListItem>
          <ListItem>
            <Typography>
              - {t("introductions.addActivities.example6")}
            </Typography>
          </ListItem>
          <ListItem>
            <Typography>
              - {t("introductions.addActivities.example7")}
            </Typography>
          </ListItem>
          <ListItem>
            <Typography>
              - {t("introductions.addActivities.example8")}
            </Typography>
          </ListItem>
          <ListItem>
            <Typography>
              - {t("introductions.addActivities.example9")}
            </Typography>
          </ListItem>
          <ListItem>
            <Typography>
              - {t("introductions.addActivities.example10")}
            </Typography>
          </ListItem>
        </List>
      </Collapse>
    </>
  );
}
